<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
<div class="relative">
  <div class="vx-navbar-wrapper navbar-full p-0">
    <vs-navbar style = "padding: 0 !important; padding-left: 20px; padding-right: 20px;" class="navbar-custom navbar-skelton" :class="navbarClasses"  :style="navbarStyle" :color="navbarColor">
      <!-- <bookmarks :navbarColor="navbarColor" v-if="windowWidth >= 992" /> -->
      <router-link style tag="div" to="/dashboard" class="vx-logo cursor-pointer mx-auto flex items-center">
        <logo class="w-10 mr-4 fill-current text-primary" />
        <span class="vx-logo-text text-primary"></span>
      </router-link>
      <h-nav-menu
        :class="[
          {'text-white' : isNavbarDark  && !isThemeDark},
          {'text-base'  : !isNavbarDark && isThemeDark}
        ]"
        :navMenuItems="navMenuItems" />

      <!-- <router-link style = "min-width: 170px; cursor: pointer" tag="div" to="/user/topic/manage" class="vx-logo cursor-pointer mx-auto flex items-center">
        <feather-icon icon="PlusIcon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer"/>
        <span class="ml-2">Thêm chủ đề</span>

      </router-link> -->

      <!-- <notification-drop-down /> -->

      <!-- <support/> -->

      <!-- <i18n /> -->

      <!-- <WarningNotify :freshData="data"/> -->

      <!-- <profile-drop-down /> -->

      <!-- <popup-package /> -->

    </vs-navbar>
  </div>
</div>
</template>

<script>
import Bookmarks            from "./components/Bookmarks.vue"
import SearchBar            from "./components/SearchBar.vue"
import NotificationDropDown from "./components/NotificationDropDown.vue"
import ProfileDropDown      from "./components/ProfileDropDown.vue"
import Logo                 from "../Logo.vue"
import HNavMenu             from "../horizontal-nav-menu/HorizontalNavMenu"
import PopupPackage      from "./components/PopupPackage.vue"
// import Support from './components/Support.vue'
// import WarningNotify from '../../../views/pages/warning-notify/WarningNotify.vue'
import I18n                 from "./components/I18n.vue"

export default {
  name: "the-navbar-horizontal",
  props: {
    logo: { type: String                                                                                                          },
    navbarType: {
      type: String,
      required: true
    },
    navMenuItems: {
      type: Array
    },
    isNavbarDark: {
      type: Boolean
    },
    isThemeDark: {
      type: Boolean
    }
  },
  components: {
    Logo,
    Bookmarks,
    SearchBar,
    NotificationDropDown,
    ProfileDropDown,
    HNavMenu,
    PopupPackage,
    // Support,
    // WarningNotify,
    I18n
  },
  computed: {
    navbarColor() {
      let color = "#fff"
      if (this.navbarType === "sticky") color = "white"
      else if (this.navbarType === 'static') {
        if (this.scrollY < 50) {
          color = "white"
        }
      }

      this.isThemedark === "dark" ? color === "#fff" ? color = "#10163a" : color = "#262c49" : null

      return color
    },
    isThemedark()          { return this.$store.state.theme                                                                       },
    navbarStyle()          { return this.navbarType === "static" ? {transition: "all .25s ease-in-out"} : {}                      },
    navbarClasses()        { return this.scrollY > 5 && this.navbarType === "static" ? null : "d-theme-dark-light-bg shadow-none" },
    scrollY()              { return this.$store.state.scrollY                                                                     },
    verticalNavMenuWidth() { return this.$store.state.verticalNavMenuWidth                                                        },
    windowWidth()          { return this.$store.state.windowWidth                                                                 },
  },
  data(){
    return{
    data:null
    }
  },
  mounted(){
    this.$eventBus.$on('loadDataNotify',($event) =>{
        this.data = $event;
    });
  }
}

</script>

